import { initPageMove as init } from "../components/PageMoveTool";

/**
 * 관리자 페이지에서 [data-bulk-target-scope][data-move-url] 마크업에
 * PageMoveTool 을 자동 부착한다. GlobalApplication.runAdmin() 에서 1회 호출.
 */
export function initPageMove(scope: HTMLElement = document.body): void {
    init(scope);
}
